import React from "react"
import { ArrowRight, ArrowDown } from "~/library/UIkit/Icons"
import styles from "./AccordionSection.module.scss"

type AccordionSectionProps = {
  title: string
  arrowBeforeTitle?: boolean
  isExpanded: boolean
  onToggle: () => void
  children?: React.ReactNode
  headerClassName?: string
}

const AccordionSection = ({
  title,
  arrowBeforeTitle,
  isExpanded,
  onToggle,
  children,
  headerClassName = "",
}: AccordionSectionProps) => {
  return (
    <div className={styles.collapsibleSection}>
      <div
        className={`${styles.sectionHeader} ${arrowBeforeTitle ? "" : styles.spaceBetween}`}
        onClick={onToggle}
      >
        {arrowBeforeTitle && (
          <div className={`${styles.collapseIcon} ${isExpanded ? styles.halfExpanded : ""}`}>
            <ArrowRight />
          </div>
        )}
        <span className={headerClassName}>{title}</span>
        {!arrowBeforeTitle && (
          <div className={`${styles.collapseIcon} ${isExpanded ? styles.expanded : ""}`}>
            <ArrowDown />
          </div>
        )}
      </div>

      <div
        className={`${styles.sectionContent} ${isExpanded ? styles.expanded : styles.collapsed}`}
      >
        <div className={styles.contentInner}>{children}</div>
      </div>
    </div>
  )
}

export default AccordionSection
